export interface WizardField {
  name: string;
  type: 'text' | 'number' | 'textarea' | 'image';
  label: string;
  required?: boolean;
}

export interface WizardGroup {
  key: string;
  label: string;
  fields: WizardField[];
}

export interface WizardStep {
  key: string;
  label: string;
  groups: WizardGroup[];
}

export interface WizardConfig {
  wizard: {
    steps: WizardStep[];
  };
}

export const WIZARD_CONFIG: WizardConfig = {
  wizard: {
    steps: [
      {
        key: 'company',
        label: 'Votre entreprise',
        groups: [
          {
            key: 'company_legal',
            label: 'Identité administrative',
            fields: [
              { name: 'company_name', type: 'text', label: 'Nom entreprise', required: true },
              { name: 'company_rc_number', type: 'text', label: 'Numéro R.C', required: true },
              { name: 'company_tahiti_number', type: 'text', label: 'Numéro Tahiti', required: true },
              { name: 'company_siret_siren', type: 'text', label: 'Numéro Siret/Siren' }
            ]
          },
          {
            key: 'company_contact',
            label: 'Coordonnées',
            fields: [
              { name: 'company_address', type: 'text', label: 'Adresse', required: true },
              { name: 'company_zipcode', type: 'text', label: 'Code postal', required: true },
              { name: 'company_city', type: 'text', label: 'Ville', required: true },
              { name: 'company_country', type: 'text', label: 'Pays', required: true },
              { name: 'company_phone', type: 'text', label: 'Téléphone', required: true },
              { name: 'company_email', type: 'text', label: 'Email', required: true }
            ]
          },
        ]
      }
    ]
  }
};

/** Tous les noms de champs du wizard (pour chargement/sauvegarde settings) */
export function getAllWizardFieldNames(): string[] {
  const names: string[] = [];
  for (const step of WIZARD_CONFIG.wizard.steps) {
    for (const group of step.groups) {
      for (const field of group.fields) {
        names.push(field.name);
      }
    }
  }
  return names;
}
